import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import targetProcess from '../../src/redux/reducers/targetProcess';
import currentUser from '../../src/redux/reducers/currentUser';
import homeLists from '../../src/redux/reducers/homeLists';
import navigatorPermissions from '../../src/redux/reducers/navigatorPermissions';
import techCheck from '../../src/redux/reducers/techCheck';
import GlobalAnalyticsAdapterReducer from '../../src/redux/reducers/GlobalAnalyticsAdapterReducer';
import SVOD from '../../src/redux/reducers/SVOD';

const enhancers = [
	applyMiddleware(reduxThunk),
];

let rootReducers = combineReducers({
	targetProcess,
	currentUser,
	homeLists,
	navigatorPermissions,
	techCheck,
	GlobalAnalyticsAdapterReducer,
	SVOD
});

const store = createStore(
	rootReducers, // reducer
	{}, // preloadedState
	compose(...enhancers) // enhancer
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js